import React from "react"

import { useNavigate } from "react-router-dom"

import { Button } from "@/components/ui/button"
import { useAuth } from "@/contexts/AuthContext"
import { getDefaultHomePageForRole } from "@/utils/roleUtils"

const NoPermission: React.FC = () => {
  const navigate = useNavigate()
  const { claims } = useAuth()

  const goToDefaultPage = () => {
    const homePage = getDefaultHomePageForRole(claims.user_role)
    navigate(homePage)
  }

  return (
    <div className="min-h-screen bg-palette-jungleGreen000 flex flex-col justify-center items-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <img
            alt="DriverHive"
            className="mx-auto h-12"
            src="/images/b324345a-d7f5-4435-8a45-ce025baae0be.png"
          />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-palette-jungleGreen900">
            Access Denied
          </h2>
          <p className="mt-2 text-center text-sm text-palette-jungleGreen600">
            You don't have permission to access this page
          </p>
        </div>

        <div className="mt-8">
          <Button onClick={goToDefaultPage} className="w-full">
            Go to Dashboard
          </Button>

          <Button onClick={() => navigate(-1)} variant="outline" className="w-full mt-4">
            Go Back
          </Button>
        </div>
      </div>
    </div>
  )
}

export default NoPermission
